<template>
  <JobApplyLayout :step="0">
    <div v-if="!canSubmitJob" class="wrapper">
      <SubmissionRestrictedAlert :job="job" :show-notify="false" />
    </div>
    <div class="wrapper">
      <JobApplyDetail
        :job="job"
        :user="user"
        :token="token"
        :show-job-commission="false"
        :show-job-status-sticker="false"
        :show-candidate-status="false"
        :show-post-date="false"
        :show-job-key-points="false"
      />
    </div>
    <div v-if="canSubmitJob" class="btn-group">
      <button class="btn-close" @click="goToHome">
        I’m not interested in this job
      </button>
      <div class="b-g">
        <JobApplyButton
          v-if="formType === 'both' || formType === 'full'"
          :job="job"
          :token="token"
          :form-label="requiredCV"
          :form-type="'full'"
        />
        <JobApplyButton
          v-if="formType === 'both' || formType === 'simple'"
          :job="job"
          :token="token"
          :form-label="optionalCV"
          :form-type="'simple'"
        />
      </div>
    </div>
    <div v-else class="wrapper">
      <SubmissionRestrictedAlert :job="job" :show-notify="false" />
    </div>
  </JobApplyLayout>
</template>

<script>
import JobApplyLayout from 'components/layouts/job_apply/JobApplyLayout.vue'
import JobApplyDetail from 'components/ui/JobApplyDetail.vue'
import JobApplyButton from 'components/ui/button/JobApplyButton.vue'
import SubmissionRestrictedAlert from 'components/ui/alert/SubmissionRestrictedAlert.vue'

const ViewProps = window._application.props

export default {
  components: {
    JobApplyLayout,
    JobApplyDetail,
    JobApplyButton,
    SubmissionRestrictedAlert,
  },

  data() {
    const form = ViewProps.form

    return {
      job: form.userJobShare.job,
      user: form.userJobShare.user,
      token: form.userJobShare.token,
      formType: form.userJobShare.formType,
      requiredCV: '(Require CV)*',
      optionalCV: '(Optional CV)',
    }
  },

  computed: {
    canSubmitJob() {
      return this.job.jobShareable && !this.job.submissionRestricted
    },
  },

  methods: {
    goToHome() {
      window.location.href = '/'
    },
  },
}
</script>

<style scoped lang="scss">
@import 'stylesheets/global';

.details {
  padding: 20px 50px;
}

.btn-group {
  display: flex;
  justify-content: center;
  padding: 2rem 0;

  button {
    border: 1px solid #3742fa;
    border-radius: 100rem;
    color: white;
    cursor: pointer;
    font-size: 1rem;
    font-style: normal;
    font-weight: 700;
    padding: 1rem 1.5rem;
    text-align: center;

    &.btn-close {
      background-color: white;
      color: $blue-primary;
      margin-right: 10px;
    }
  }
}

@include sp {
  .details {
    padding: 10px;
  }

  .btn-group {
    align-items: flex-end;
    padding: 10px 0;

    button {
      font-size: 13px;
      padding: 10px 15px;
    }
  }
}
</style>
